module.exports = __webpack_public_path__ + "img/simon-pro.be83687f.jpg";